<template>
  <el-container direction="vertical" id="insureManagement">
    <el-row class="row-bg">
      <!-- 头部 -->
      <el-header>
        <el-col :span="24" style="text-align: center">
          <div>
            <span class="p-title">{{dynamicValidateForm.projectName}}</span>
          </div>
        </el-col>
        <el-col :span="14" :push="5" class="my-step">
          <el-steps :active="0" align-center>
            <el-step title="选择投保方案"></el-step>
            <el-step title="填写投保信息"></el-step>
            <el-step title="在线支付"></el-step>
            <el-step title="完成投保"></el-step>
          </el-steps>
        </el-col>
      </el-header>
    </el-row>
    <el-main>
      <!-- 表单计划 -->
      <el-row>
        <el-col :span="16" :push="4">
          <el-form :model="dynamicValidateForm" id="planLocation" ref="dynamicValidateForm" label-width="204px" class="demo-dynamic" style="text-align: left">
            <el-card class="box-card">
              <span v-for="(item, index) in dynamicValidateForm.skuSpecList">
                <el-form-item v-if="$$.isValidObj(dynamicValidateForm.skuSpecList[dynamicValidateForm.skuSpecList.length-1].value[0].specName) && item.value[0].type !== 4 && item.value[0].type !== 6 " :key="index" :label= "item.name" class="form-item-label">
                  <el-select v-if="item.value.length === 1 && item.name !== '保险方案' " class="form-item-input my-input select-arrowhead" :disabled="true"
                             v-model="dynamicValidateForm.skuSpecNameList[index]" style="width: 250px">
                    <el-option
                      v-for="i in item.value"
                      :key="i.id"
                      :label="i.specName"
                      :value="i.specName">
                    </el-option>
                  </el-select>
                  <el-button v-else-if="item.name === '保险方案'" :class="dynamicValidateForm.planId === plan.id ? 'true' : 'false'" style="width: 200px;min-width: 144px;border: 0px"
                             v-for="plan in dynamicValidateForm.planIds" :key="plan.id" @click="planChange(plan.id)"> {{plan.name}}
                  </el-button>
                  <el-select v-else class="form-item-input my-input"
                             v-model="dynamicValidateForm.skuSpecNameList[index]" style="width: 250px" @change="hurtChange(1, item.value[0].type, index)">
                    <el-option
                      v-for="i in item.value"
                      :key="i.id"
                      :label="i.specName"
                      :value="i.specName">
                    </el-option>
                  </el-select>
                </el-form-item>
                <span v-for="t in dynamicValidateForm.skuSpecList" v-if="t.value[0].type === 7 && $$.isValidObj(t.value[0].specName) &&
                 $$.isValidObj(dynamicValidateForm.attachSkuSpecName) && dynamicValidateForm.attachSkuSpecName  !== '0'">
                <el-form-item v-if="$$.isValidObj(dynamicValidateForm.skuSpecList[dynamicValidateForm.skuSpecList.length-1].value[0].specName) && (item.value[0].type === 4 || item.value[0].type === 6) " :key="index" :label= "item.name" class="form-item-label">
                  <el-select v-if="item.value.length === 1 && item.name !== '投保单位' && item.name !== '保险方案' " class="form-item-input my-input select-arrowhead" :disabled="true"
                             v-model="dynamicValidateForm.skuSpecNameList[index]" style="width: 250px">
                    <el-option
                      v-for="i in item.value"
                      :key="i.id"
                      :label="i.specName"
                      :value="i.specName">
                    </el-option>
                  </el-select>
                </el-form-item>
                </span>
              </span>
              <el-form-item v-for="(item,index) in dynamicValidateForm.skuSpecList" v-if="item.value[0].type === 7 && $$.isValidObj(item.value[0].specName) &&
               $$.isValidObj(dynamicValidateForm.attachSkuSpecName) && dynamicValidateForm.attachSkuSpecName !== '0'"
                            label= "投保人数" class="form-item-label" :key="index">
                <el-input class="form-item-input my-input" @input="hurtChange(2, 0, 0)" style="width: 250px"
                          v-model="dynamicValidateForm.groupSize"  placeholder="请输入雇主责任险投保人数"></el-input>
              </el-form-item>
              <el-table
                :data="insureEnsureList"
                :span-method="objectSpanMethod"
                border
                max-height="900"
                class="my-el-table"
                style="margin-left: 0;text-align: center">
                <el-table-column
                  prop="type"
                  label="险种"
                  width="200">
                </el-table-column>
                <el-table-column
                  prop="name"
                  label="保障内容">
                </el-table-column>
                <el-table-column
                  prop="money"
                  width="200"
                  label="保额（元）">
                </el-table-column>
                <el-table-column
                  prop="detail"
                  label="说明">
                </el-table-column>
              </el-table>
            </el-card>
            <el-form-item class="functionBlocks" style="text-align: right">
              <div>保费：<span style="color: red;font-size: 30px">{{dynamicValidateForm.money}}</span> 元</div>
            </el-form-item>
            <div class="submitOrder">
              <el-button @click="insureOrder" class="header-button-order-add">立即投保</el-button>
            </div>
          </el-form>
        </el-col>
      </el-row>
      <!-- 产品详情 -->
      <el-row type="flex" justify="center" style="padding-bottom: 80px">
        <el-col :span="16">
          <template>
            <el-tabs v-model="activeName">
              <el-tab-pane label="产品简介" name="first" v-html="insuranceInfo.unscramble"></el-tab-pane>
              <el-tab-pane label="投保须知" name="second" v-html="insuranceInfo.ensureExplainContent"></el-tab-pane>
              <el-tab-pane label="理赔服务" name="third" v-html="insuranceInfo.claimsServices"></el-tab-pane>
              <el-tab-pane label="常见问题" name="four" v-html="insuranceInfo.commonProblem"></el-tab-pane>
            </el-tabs>
          </template>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>

<script type="text/javascript">

  import {Loading} from 'element-ui';
  import baseUrl from '../../../tool/baseUrl';

  export default {
    name: "sinosafeInsureManagement",
    data() {
      return {
        dynamicValidateForm: {
          formItemPlanName : '保险方案',
          companyName: '',
          guaranteePeriod:'',
          insuranceAge: '',
          planId: 1697,
          planIds: [],
          skuSpecListAll:[],
          skuSpecList: [{
            value : [{
              specName : ''
            }]
          }],
          occupationList: [],
          occTwoList: [],
          occThreeList: [],
          occOneId:'',
          occOneName: '',
          occTwoId: '',
          occTwoName: '',
          occThreeId:'',
          occThreeName:'',
          skuSpecNameList:[],
          attachSkuSpecName : '',
          attachSkuTrueSpecName :'',
          attachSkuSpecValue : '',
          realityOccCode:'',
          azcnCode:'',
          skuList: [],
          groupSize : '',
          skuInfo: '',
          beShareToken:'',
          productId: 100424
        },
        activeName: 'first',
        insuranceInfo: {
          unscramble:'',
          ensureExplainContent:'',
          claimsServices:'',
          commonProblem:'',
          insurancePlanData:[]
        },
        spanObj:[],
        insureEnsureList:[],
      };
    },
    methods: {
      //-- 点击计划时
      planChange(id){
        this.axios.post('/management/mobileInsuranceInfo/getInsuranceSkuDetail?insuranceInfoId=' + this.dynamicValidateForm.productId + '&planId=' + id, {}).then((response) => {
            let data = response.data;
            if (data.success) {
              this.dynamicValidateForm.skuSpecList = [];
              this.dynamicValidateForm.groupSize = '';
              this.dynamicValidateForm.skuInfo = {};
              this.dynamicValidateForm.money = '';
              this.dynamicValidateForm.skuSpecListAll = data.datas.skuSpecList;
              this.dynamicValidateForm.skuSpecListAll[id].forEach(item => {
                if(item.value[0].type === 1){
                  this.dynamicValidateForm.skuSpecList.push(item);
                  let planName = {};
                  planName.name = this.dynamicValidateForm.formItemPlanName;
                  planName.value = [{type : ''}];
                  this.dynamicValidateForm.skuSpecList.push(planName);
                }else {
                  this.dynamicValidateForm.skuSpecList.push(item);
                }
              });
              this.dynamicValidateForm.skuSpecList.forEach(item => {
                if(item.value[0].type === 1){
                  this.dynamicValidateForm.guaranteePeriod = item.value[0].specName;
                }else if (item.value[0].type === 6){
                  this.dynamicValidateForm.insuranceAge = item.value[0].specName;
                }
              });

              let length = 0;
              this.dynamicValidateForm.skuSpecNameList = [];
              this.dynamicValidateForm.attachSkuSpecName = '';
              this.dynamicValidateForm.skuSpecList.forEach(item => {
                if ( item.value.length === 1 && item.name !== this.dynamicValidateForm.formItemPlanName){
                  this.dynamicValidateForm.skuSpecNameList.push(item.value[0].specName);
                }else {
                  this.dynamicValidateForm.skuSpecNameList.push('');
                }
                if (length < item.name.length) length = item.name.length;
              });
              this.dynamicValidateForm.planId = id;
              this.showInsurancePlan();
            }
        });
        /*$('.form-item-label .el-form-item__label').css('width', `${length*18}px`);
        $('.form-item-label .el-form-item__content').css('margin-left', `${length*18}px`);*/
      },
      //-- 获取 - 产品详情
      getInsurance() {
        let insuranceInfoId = '100424';//insuranceInfoId == productId
        let that = this;
        this.axios.post('/management/mobileInsuranceInfo/getInsurance?insuranceInfoId='+this.dynamicValidateForm.productId).then((response) => {
          if(response.data.success){
            const {claimsServices, commonProblem, ensureExplainContent, unscramble, projectName, insurancePlanData} = response.data.datas;
            this.insuranceInfo = {
              unscramble,
              ensureExplainContent,
              claimsServices,
              commonProblem,
              insurancePlanData
            };
            this.insuranceInfo.insurancePlanData.forEach(item => {
              item.insureEnsureData.forEach(o => {
                if(this.$$.isValidObj(o.detail)) o.detail = o.detail.toString().replace(/[<p>/]/g,'');
              });
            });
            if (this.$$.isValidObj(projectName)) this.dynamicValidateForm.projectName = projectName;
            this.getSkuInfo();
          }else {
            that.$$.confirm({
              message: response.data.msg,
              onOk: function () {
                that.$router.push({name: `index`});
              },
              onCancel: function () {
                that.$router.push({name: `index`});
              }
            });
          }
        })
      },
      hurtChange(i, type, index) {
        this.$forceUpdate();
        // console.log( "this.dynamicValidateForm.skuSpecNameList[index]");
        // console.log(this.dynamicValidateForm.skuSpecNameList);
        // console.log( this.dynamicValidateForm.skuSpecNameList[index]);
        // console.log( this.dynamicValidateForm.skuSpecList);

        if ( i === 1 ) this.dynamicValidateForm.groupSize = '', this.dynamicValidateForm.money = '';
        if ( i === 1 && type === 7 ){
            this.dynamicValidateForm.skuSpecList[index].value.forEach((item, indexOne) => {
                // console.log(item.specName);
                if (item.specName ===  this.dynamicValidateForm.skuSpecNameList[index]){
                    // console.log(item.specName);
                    this.dynamicValidateForm.attachSkuSpecName =  item.specValue;
                    this.dynamicValidateForm.attachSkuTrueSpecName =  item.specName;
                }
            });
        }
        this.dynamicValidateForm.groupSize = this.dynamicValidateForm.groupSize.replace(/[^\d]/g,'');
        if(this.dynamicValidateForm.groupSize.length > 4){
          this.dynamicValidateForm.groupSize = this.dynamicValidateForm.groupSize.substring(0,4);
          return;
        }
        let dataTitle = "";
        if ( i === 1 && type === 7 )
          this.showInsurancePlan();
        //
        try {
          this.dynamicValidateForm.skuSpecList.forEach((item, index) => {
            if (item.name !== this.dynamicValidateForm.formItemPlanName) {
              if(item.value[0].type === 7 && this.dynamicValidateForm.attachSkuSpecName === "0" ) this.dynamicValidateForm.groupSize = 1;
              if (!this.$$.isValidObj(this.dynamicValidateForm.skuSpecNameList[index])) {
                throw new Error;
              }else{
                dataTitle += this.dynamicValidateForm.skuSpecNameList[index]+'-';
              }
            }
          });
        } catch (e) {
          return;
        }

        dataTitle = dataTitle.substring(0,dataTitle.length - 1);
        let params = {};
        let skuSpec = [];
        skuSpec.push(dataTitle);
        params.insuranceInfoId = this.dynamicValidateForm.productId;
        params.planId = this.dynamicValidateForm.planId;
        params.skuSpec = skuSpec;
        this.axios.post('/management/mobileInsuranceInfo/getskuSpecRateInfo', this.qs.stringify(params,{indices: false})).then((response) => {
          let data = response.data;
          if( data.success ){
            this.dynamicValidateForm.skuInfo = data.data[0];
            if(this.$$.isValidObj(this.dynamicValidateForm.groupSize)) this.premiumCount();
          }
        });
      },
      showInsurancePlan(){
        this.$forceUpdate();
        this.insureEnsureList = [];
        try {
            // console.log(this.dynamicValidateForm.attachSkuSpecName === "0");
            if (this.dynamicValidateForm.attachSkuSpecName === "0") {
                this.insuranceInfo.insurancePlanData.forEach(item => {
                    if (item.planId === this.dynamicValidateForm.planId) {
                        item.insureEnsureData.forEach(o => {
                            if( o.type.toString().indexOf("雇主责任") === -1 )
                                this.insureEnsureList.push(o);
                        });
                        this.spanObj = this.$$.dataMethod(this.insureEnsureList);
                        throw new Error;
                    }
                });
            }else if(this.$$.isValidObj(this.dynamicValidateForm.attachSkuSpecName) && this.dynamicValidateForm.attachSkuSpecName !== "0"){
                // console.log("循环");
                this.insuranceInfo.insurancePlanData.forEach(item => {
                    if (item.planId === this.dynamicValidateForm.planId) {
                        item.insureEnsureData.forEach(o => {
                            this.insureEnsureList.push(o);
                        });
                        this.spanObj = this.$$.dataMethod(this.insureEnsureList);
                        throw new Error;
                    }
                });
            }else if(!this.$$.isValidObj(this.dynamicValidateForm.attachSkuSpecName)){
                this.insuranceInfo.insurancePlanData.forEach(item => {
                    if (item.planId === this.dynamicValidateForm.planId) {
                        item.insureEnsureData.forEach(o => {
                            if( o.type.toString().indexOf("雇主责任") === -1 )
                                this.insureEnsureList.push(o);
                        });
                        this.spanObj = this.$$.dataMethod(this.insureEnsureList);
                        throw new Error;
                    }
                });
            }
          /*this.dynamicValidateForm.skuSpecList.forEach((item, index) => {
            if (item.value[0].type === 7 && this.dynamicValidateForm.attachSkuSpecName === item.value[0].specValue) {
              this.insuranceInfo.insurancePlanData.forEach(item => {
                if (item.planId === this.dynamicValidateForm.planId) {
                  item.insureEnsureData.forEach(o => {
                    if( o.type.toString().indexOf("雇主责任") === -1 )
                     this.insureEnsureList.push(o);
                  });
                  this.spanObj = this.$$.dataMethod(this.insureEnsureList);
                  throw new Error;
                }
              });
            }else if(item.value[0].type === 7 && this.$$.isValidObj(this.dynamicValidateForm.attachSkuSpecName) && this.dynamicValidateForm.attachSkuSpecName !== item.value[0].specName){
                console.log("循环");
              this.insuranceInfo.insurancePlanData.forEach(item => {
                if (item.planId === this.dynamicValidateForm.planId) {
                  item.insureEnsureData.forEach(o => {
                      this.insureEnsureList.push(o);
                  });
                  this.spanObj = this.$$.dataMethod(this.insureEnsureList);
                  throw new Error;
                }
              });
            }else if(item.value[0].type === 7 && !this.$$.isValidObj(this.dynamicValidateForm.attachSkuSpecName)){
              this.insuranceInfo.insurancePlanData.forEach(item => {
                if (item.planId === this.dynamicValidateForm.planId) {
                  item.insureEnsureData.forEach(o => {
                    if( o.type.toString().indexOf("雇主责任") === -1 )
                      this.insureEnsureList.push(o);
                  });
                  this.spanObj = this.$$.dataMethod(this.insureEnsureList);
                  throw new Error;
                }
              });
            }
          });*/
        } catch (e) {
        }
      },
      getSkuInfo() {
        this.axios.post('/management/mobileInsuranceInfo/getInsuranceSkuDetail?insuranceInfoId=' + this.dynamicValidateForm.productId + '&planId=' + this.dynamicValidateForm.planId, {}).then((response) => {
          let data = response.data;
          if (data.success) {
            this.dynamicValidateForm.skuSpecListAll = data.datas.skuSpecList;
            this.dynamicValidateForm.skuSpecList = [];
            let siNoSafeDynamicValidateForm = sessionStorage.getItem('siNoSafeDynamicValidateForm'+ this.dynamicValidateForm.productId);
            if(this.$$.isValidObj(siNoSafeDynamicValidateForm)){
              siNoSafeDynamicValidateForm = JSON.parse(siNoSafeDynamicValidateForm);
              this.dynamicValidateForm = siNoSafeDynamicValidateForm;
              this.showInsurancePlan();
            }else {
              data.planList.forEach(item => {
                /*if( item.id !== 1695 )*/ this.dynamicValidateForm.planIds.push(item);
              });
              // this.dynamicValidateForm.planId = this.dynamicValidateForm.planIds[0].id;
              data.datas.skuSpecList[this.dynamicValidateForm.planId].forEach(item => {
                if(item.value[0].type === 1){
                  this.dynamicValidateForm.skuSpecList.push(item);
                  let planName = {};
                  planName.name = this.dynamicValidateForm.formItemPlanName;
                  planName.value = [{type : ''}];
                  this.dynamicValidateForm.skuSpecList.push(planName);
                }else {
                  this.dynamicValidateForm.skuSpecList.push(item);
                }
              });
              this.showInsurancePlan();
              this.dynamicValidateForm.skuSpecList.forEach(item => {
                if(item.value[0].type === 1){
                  this.dynamicValidateForm.guaranteePeriod = item.value[0].specName;
                }else if (item.value[0].type === 6){
                  this.dynamicValidateForm.insuranceAge = item.value[0].specName;
                }
              });

              let length = 0;
              this.dynamicValidateForm.skuSpecList.forEach(item => {
                if (item.value.length === 1 && item.name !== this.dynamicValidateForm.formItemPlanName){
                  this.dynamicValidateForm.skuSpecNameList.push(item.value[0].specName);
                }else {
                  this.dynamicValidateForm.skuSpecNameList.push('');
                }
                if (length < item.name.length) length = item.name.length;
              });
              $('.form-item-label .el-form-item__label').css('width', `${length*18}px`);
              $('.form-item-label .el-form-item__content').css('margin-left', `${length*18}px`);
            }
          }
        });
      },
      objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        //列合并
        let _row = this.spanObj[column.property]?this.spanObj[column.property][rowIndex]:1;
        let _col = _row>0?1:0;
        return {
          rowspan: _row,
          colspan: _col
        }
      },
      // -- 数据校验
      dataIsValid() {
        let isValid = true;
        const reg = /^\d+$/;
        /*if (!this.dynamicValidateForm.companyName.trim()) {
          this.$message.error("投保单位不能为空!");
          return isValid = false;
        }*/
        try {
          this.dynamicValidateForm.skuSpecNameList.forEach((item, index) => {
              if( !this.$$.isValidObj(item) ){
                if( this.dynamicValidateForm.skuSpecList[index].name !== this.dynamicValidateForm.formItemPlanName ){
                  document.getElementById("planLocation").scrollIntoView();
                  throw new Error(this.dynamicValidateForm.skuSpecList[index].name+"不能为空!");
                }
              }
          });
        } catch (e) {
          this.$message.error(e.message);
          return isValid = false;
        }
        if (!this.$$.isValidObj(this.dynamicValidateForm.skuInfo.id)) {
          document.getElementById("planLocation").scrollIntoView();
          this.$message.error("保障项目不能为空!");
          return isValid = false;
        }
        if (!this.$$.isValidObj(this.dynamicValidateForm.groupSize) || this.dynamicValidateForm.groupSize <= 0) {
          this.$message.error("投保人数不能为空!");
          document.getElementById("planLocation").scrollIntoView();
          return isValid = false;
        }
        if (!reg.test(this.dynamicValidateForm.groupSize)) {
          this.$message.error("投保人数只能填写数字!");
          document.getElementById("planLocation").scrollIntoView();
          return isValid = false;
        }
        return isValid;
      },
      //-- 数据拼接
      quoteMainData() {
        // -- 主数据
        let quoteMainData = {};
        // -- 计划数据
        let ensurePlan = {};
        let skuIds = '';
        quoteMainData.productId = this.dynamicValidateForm.productId;
        quoteMainData.planId = this.dynamicValidateForm.planId;
        quoteMainData.companyName = "-";
        // -- ensurePlan内部数据
        let map = {};
        skuIds += this.dynamicValidateForm.skuInfo.id + ",";
        // -- 人数
        map.groupSize = this.dynamicValidateForm.groupSize;
        // -- 计划SkuId
        map.skuId = this.dynamicValidateForm.skuInfo.id;
        map.occId = 0;
        ensurePlan[0] = map;

        skuIds = skuIds.slice(0, skuIds.length - 1);
        quoteMainData.skuId = skuIds;
        quoteMainData.ensurePlan = JSON.stringify(ensurePlan);
        if (this.$$.isValidObj(this.dynamicValidateForm.beShareToken)) quoteMainData.beShareToken = decodeURIComponent(encodeURIComponent(decodeURIComponent(this.dynamicValidateForm.beShareToken)).replace(/%20/g,"+"));
        return quoteMainData;
      },
      //-- 算费方法
      premiumCount(){

        let quoteMainData = this.quoteMainData();

        this.axios.post('/management/quotemaininfo/premiumCount', quoteMainData).then((response) => {
          if (response.data.success) {
            this.$forceUpdate();
            this.dynamicValidateForm.money = response.data.discountPremium;
          }else {
            this.dynamicValidateForm.money = '';
            // this.dynamicValidateForm.groupSize = '';
            this.$message.error(response.data.msg);
          }
        });
      },
      //-- 立即投保跳转
      insureOrder() {

        if (!this.dataIsValid()) {
          return;
        }

        let quoteMainData = this.quoteMainData();
        let loadingInstance = Loading.service({fullscreen: true});
        this.axios.post('/management/quotemaininfo/insertQuoteMainInfo_validation', quoteMainData).then((response) => {
          if (response.data.success) {
              //页面传世
            sessionStorage.setItem('siNoSafeDynamicValidateForm' + this.dynamicValidateForm.productId, JSON.stringify(this.dynamicValidateForm));
            sessionStorage.removeItem('siNoSafeAllData'+this.dynamicValidateForm.productId); // 清理填写资料缓存

            this.$router.push({name: 'siNoSafeInsureDetails' , query: {productId : this.dynamicValidateForm.productId } });
          } else {
            this.$message.error(response.data.msg);
          }
          this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
            loadingInstance.close();
          });
        });
      },
    },
    mounted() {
      let that = this;
      if(!that.$$.isValidObj(this.$route.query.beShareToken) && !that.$$.checkLogin()) {
        that.$$.confirmLogin(this,function () {
          that.$router.push({name: `index`});
        });
        return false;
      }
      if(this.$$.isValidObj(this.$route.query.beShareToken)) this.dynamicValidateForm.beShareToken = this.$route.query.beShareToken;

      if(this.$$.isValidObj(this.$route.query.productId) && this.$$.isValidObj(this.$route.query.planId) ) {
          this.dynamicValidateForm.productId = parseInt(this.$route.query.productId) ;//产品id
          this.dynamicValidateForm.planId = parseInt(this.$route.query.planId);//1697
          // console.log( "this.$route.query.productId");
          // console.log( this.$route.query.planId);
          // console.log( this.$route.query.productId);
      }
      this.getInsurance();
    }
  }

</script>

<style scoped>
  #wap >>> .loginStatus{
    display: none!important;
  }

  .box-card {
    width: auto;
    height: auto;
    padding: 20px;
    margin-bottom: 2.5rem;
  }

  .box-card-div>span{
    position: absolute;
    right: 0;
    top: -20px;
  }

  .box-card-div-title>.header{
    text-align: center;
    position: absolute;
    left: 0;
    top: -20px;
  }

  .box-card-div>span {
    display: inline-block;
  }

  .form-item-label {
    font-weight: 500;
    color: #333333;
    position: relative;
    /*display: flex;*/
  }

  .form-item-input {
    height: 40px;
    width: 144px;
    max-width: 640px;
    background: #F7F7F7;
    margin: 0 5px 5px 10px;
    text-align: center;
    display: inline-block;
  }
  span.form-item-input {
    display: inline-block;
    background: #ffffff;
  }


  .p-title {
    font-size: 2.5rem;
    color: #333333;
    font-weight: bold;
    font-style: italic;
  }

  .row-bg {
    padding: 60px 0 40px;
  }

  .functionBlocks /deep/ .el-form-item__content{
    width: 100%;
    margin-left: 0!important;
  }

  .header-button-add {
    height: 40px;
    background: #FF7052 !important;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 500;
    color: #FFFFFF !important;
    margin-bottom: 10px;
  }

  .my-step {
    padding-top: 63px;
  }

  /* 已完成title文字颜色 */
  .my-step /deep/ .is-finish {
    font-size: 16px;
    font-weight: 500;
    font-style: italic;
    color: #FF7052;
  }

  /* 进行中title文字颜色 */
  .my-step /deep/ .is-process {
    font-size: 1rem;
    font-weight: 500;
    font-style: italic;
    color: #FF7052;
  }

  /* 等待中title文字颜色*/
  .my-step /deep/ .is-wait {
    font-size: 1rem;
    font-weight: 500;
    font-style: italic;
    color: #666666;
  }

  /* 圆圈数字颜色*/
  .my-step /deep/ .el-step__icon-inner {
    padding-right: 6px;
    font-size: 1.5rem;
    font-style: italic !important;
    font-weight: 800;
    color: #FFFFFF;
  }

  /* 圆圈数字颜色*/
  .my-step /deep/ .el-step__icon-inner:before {
    content: '0';
  }

  /*is-text 圆圈颜色*/
  .my-step /deep/ .is-finish .is-text {
    background: #EB6F67 !important;
    border-color: #EB6F67 !important;
    width: 56px;
    height: 56px;
    margin-top: -45px;
  }

  /*is-text 圆圈颜色*/
  .my-step /deep/ .is-process .is-text {
    background: #EB6F67 !important;
    border-color: #EB6F67 !important;
    width: 56px;
    height: 56px;
    margin-top: -45px;
  }

  /*is-text 圆圈颜色*/
  .my-step /deep/ .is-wait .is-text {
    background: #CCCCCC !important;
    border-color: #CCCCCC !important;
    width: 56px;
    height: 56px;
    margin-top: -45px;
  }

  /*is-finish 圆圈颜色*/
  .my-step /deep/ .el-steps.el-steps--horizontal {
    color: #EB6F67 !important;
    border-color: #EB6F67 !important;

  }

  .my-step /deep/ .el-step.is-horizontal.is-center {
    color: #EB6F67 !important;
    border-color: #EB6F67 !important;
  }

  .my-step /deep/ .el-step__head.is-finish {
    color: #EB6F67 !important;
    border-color: #EB6F67 !important;
  }

  /*is-process 圆圈颜色*/
  .my-step /deep/ .el-steps.el-steps--horizontal {
    color: #FF7052;
    border-color: #FF7052;
  }

  .my-step /deep/ .el-step__head.is-process {
    color: #FF7052;
    border-color: #FF7052;
  }

  .my-step /deep/ .el-step.is-horizontal.is-center {
    color: #FF7052;
    border-color: #FF7052;
  }

  /* 输入框去圆角 */
  .my-input /deep/ .el-input__inner {
    border: 0 !important;
    font-size: 1rem;
    font-weight: 400;
    color: #333333 !important;
    background-color: #F7F7F7 !important;
    text-align: center !important;
  }

  /* 输入框文字左对齐 */
  .my-input-left /deep/ .el-input__inner {
    border: 0 !important;
    font-size: 16px;
    font-weight: 400;
    color: #333333 !important;
    background-color: #F7F7F7 !important;
    text-align: left !important;
  }

  /* 必填框去掉*号 */
  .form-item-label /deep/ .el-form-item__label:before {
    color: #FFFFFF !important;
    margin-right: 0!important;
    content: '' !important;
  }

  .form-item-label /deep/ .el-form-item__label {
    font-size: 1rem !important;
    margin: 0 auto;
  }

  .select-arrowhead /deep/ .el-select__caret{
    display: none;
  }

  .true{
    color: #FFFFFF!important;
    background-color: #f2613f!important;
    height: 40px;
    width: 144px;
    max-width: 640px;
    margin: 0 5px 5px 10px;
    text-align: center;
    display: inline-block;
  }
  .false{
    height: 40px;
    width: 144px;
    max-width: 640px;
    background: #F7F7F7;
    margin: 0 5px 5px 10px;
    text-align: center;
    display: inline-block;
  }

  /* 输入框文字左对齐 */
  .true /deep/ .el-input__inner {
    border: 0 !important;
    font-size: 16px;
    font-weight: 400;
    color: #FFFFFF!important;
    background-color: #f2613f!important;
    text-align: left !important;
  }

  /* 输入框文字左对齐 */
  .false /deep/ .el-input__inner {
    border: 0 !important;
    font-size: 16px;
    font-weight: 400;
    color: #333333 !important;
    background-color: #F7F7F7 !important;
    text-align: left !important;
  }

  .submitOrder{
    width: 100%;
    margin: 0 auto;
    text-align: center;
  }

  .header-button-order-add {
    width: 20rem;
    background: #FF7052 !important;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 500;
    color: #FFFFFF !important;
    margin-bottom: 25px;
  }

  .header-button-order-add:hover {
    color: #FFFFFF !important;
    background: #FF7052 !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/product/sinosafeInsurance/sinosafeInsureManagement.vue